// extracted by mini-css-extract-plugin
export default {"tag-input":"events-editing-client-js-editing-timeline-judgment-___TagInput-module__tag-input___36q_A"};